import { Component, Input } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { getLanguageCookie } from 'src/assets/language';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
  @Input() type: any // 1 

  selectedFlag: any = {
    lang: 'en',
    file: 'us.svg'
  };

  properties: any = {}

  constructor(
    private cookieService: CookieService,
    private localStorageService: LocalStorageService
  ){}

  async ngOnInit() {
    this.properties = await this.localStorageService.localStorageToJsonAsync();
  }

  getLanguages(file: string){
    return getLanguageCookie(file, localStorage.getItem('language'))
  }
}
